module.exports = __webpack_public_path__ + "img/ruiyan_04.5aba467b.jpg";